import React from 'react';
import { useLocation } from 'react-router-dom';
import '../styles/home.css';
import AnimatedBackground from '../components/AnimatedBackground';
import homeimage from '../assets/homeimage.jpg';
import { motion } from 'framer-motion';

const Home = () => {
  const location = useLocation();
  const isActive = location.pathname === '/' || location.pathname === '/home';

  return (
    <div className={`home-wrapper ${isActive ? 'active-sidebar' : ''}`}>
      <AnimatedBackground />

      {/* ===== Hero Section ===== */}
      <div className="home-overlay">
        {/* Left Side - Heading & CTA */}
        <motion.div
          className="home-left"
          initial={{ x: -80, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ duration: 0.8 }}
        >
          <h1 className="home-heading">Building Tomorrow’s Technology, Today.</h1>
          <p className="home-tagline">
            <em>“Innovation isn’t optional — it’s the future.”</em> <br />
            At <strong>NEELAverse Technologies</strong>, we don’t just create software — we engineer experiences,
            fuel business transformation, and deliver impact.
          </p>

          <div className="cta-buttons">
            <a href="/services" className="cta-btn">Explore Services</a>
            <a href="/careers" className="cta-btn secondary">Join Our Mission</a>
          </div>
        </motion.div>

        {/* Right Side - Image + Text Below */}
        <motion.div
          className="home-right"
          initial={{ x: 80, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ duration: 0.8 }}
        >
          <div className="interactive-card">
            <img src={homeimage} alt="Our Vision" />
          </div>
          <div className="card-content">
            <h3>Tech with Purpose</h3>
            <p>
              We deliver AI, Cloud, Healthcare, Travel, and Consumer-tech Solutions
              using the latest modern technologies that empower businesses and delight users.
            </p>
          </div>
        </motion.div>
      </div>

      {/* ===== Why Choose Section ===== */}
      <motion.section
        className="home-section"
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        viewport={{ once: true }}
      >
        <h2>Why Choose NEELAverse?</h2>
        <div className="features">
          <motion.div className="feature-box" whileHover={{ scale: 1.05 }}>
            <h4>🔍 Vision-Driven Engineering</h4>
            <p>
              We build digital ecosystems — not just apps. We strategize, analyze, design, and optimize every step.
            </p>
          </motion.div>

          <motion.div className="feature-box" whileHover={{ scale: 1.05 }}>
            <h4>⚙️ Scalable Custom Solutions</h4>
            <p>
              Our platforms are designed to grow with your business — built on robust architecture & the latest tech stacks.
            </p>
          </motion.div>

          <motion.div className="feature-box" whileHover={{ scale: 1.05 }}>
            <h4>💡 AI-Powered Thinking</h4>
            <p>
              We infuse intelligence into systems — from OCR to prediction engines — to automate and accelerate outcomes.
            </p>
          </motion.div>

          <motion.div className="feature-box" whileHover={{ scale: 1.05 }}>
            <h4>🌐 Industry-Wide Expertise</h4>
            <p>
              From Healthcare to Banking, from HR to OTTs — our diverse portfolio reflects global needs and bold ideas.
            </p>
          </motion.div>
        </div>
      </motion.section>

      {/* ===== Quote Section ===== */}
      <motion.section
        className="home-section quote-section"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 1 }}
      >
        <blockquote>
          "We are not just developers. We are architects of meaningful experiences.
          We don’t follow trends — we set them."
        </blockquote>
        <p className="quote-credit">— NEELAverse Technologies</p>
      </motion.section>
    </div>
  );
};

export default Home;
